import * as React from 'react';

import { Text } from '../Text';
import { Container } from '../Container';
import { NBSP } from '../../constants/symbols';
import { Video } from './Video';

import * as styles from './styles.css';

export interface IBIReportsInfoProps {
  videoUrl: string;
}

export const BIReportsInfo: React.FC<IBIReportsInfoProps> = ({ videoUrl }) => {
  return (
    <div className={styles['container']}>
      <Container>
        <div className={styles['title']}>
          <Text size="h2" bold>
            Готовые интерактивные BI-отчеты
          </Text>
        </div>

        <div className={styles['subtext']}>
          <Text>
            Обработаем данные за вас и предоставим готовые интерактивные BI-отчеты с{NBSP}аналитикой рынка недвижимости
          </Text>
        </div>

        <div className={styles['video-container']}>
          <Video videoUrl={videoUrl} />
        </div>
      </Container>
    </div>
  );
};

BIReportsInfo.displayName = 'BIReportsInfo';
